// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__PY0DZ","hoverable":"card_hoverable__0LQvx"};